import React from "react";
import { Grid } from "semantic-ui-react";
import { FiPlayCircle } from "react-icons/fi";
import ModalMultimediaVideo from "../../layout/ModalMutlimediaVideo/ModalMutlimediaVideo";
import "./styles.css";
const GalleryItemVideo = (props) => {
  const results = props.video.data.url.match("[\\?&]v=([^&#]*)");
  return (
    <>
      <Grid.Column
        className="col-12 xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ModalMultimediaVideo
          video={props}
          render={
            <>
              <div
                className="div-card"
                style={{
                  backgroundImage:
                    "url(" +
                    `https://img.youtube.com/vi/${results[1]}/0.jpg` +
                    ")",
                  backgroundSize: "cover",
                  objectFit: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="icon-play-container">
                  <FiPlayCircle color="white" size={50} />
                </div>
              </div>
              <div className="giv-text-container">
                <div
                  className="font-title"
                  style={{
                    whiteSpace: "wrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    maxWidth: 200,
                  }}
                >
                  {props.video.data.title}
                </div>
                <p>{new Date(props.video.data.date).toLocaleDateString()}</p>
              </div>
            </>
          }
        />
      </Grid.Column>
    </>
  );
};

export default GalleryItemVideo;
